import React from 'react';
import PropTypes from 'prop-types';
const TitlesTransformation = ({ title }) => {
  const text = title?.receiptTranslated?.text;
  const parsedText = text ? JSON.parse(text) : { paragraphs: [] };
  const paragraphs = parsedText.paragraphs || [];
  const lineHeightClasses = ['lh-sm'];

  return (
    <>
      {paragraphs.map((item, index) => (
        <p
          key={index}
          className={lineHeightClasses[index % lineHeightClasses.length]}
          style={{ textAlign: 'left' }}
        >
          {item.paragraph}
        </p>
      ))}
    </>
  );
};

TitlesTransformation.propTypes = {

  title: PropTypes.string,
}

export default TitlesTransformation;
